import { MediaMatcher } from '@angular/cdk/layout';
import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  Input,
  OnDestroy,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper';
import { Navigation, Pagination, Scrollbar, Autoplay, A11y } from 'swiper';
import { PrSlideComponent } from './pr-slide/pr-slide.component';
import { withNavigationButtons } from './swiper-navigation';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, A11y]);

@Component({
    selector: 'pr-swiper',
    templateUrl: './pr-swiper.component.html',
    styleUrls: ['./pr-swiper.component.scss'],
    standalone: false
})
export class PrSwiperComponent implements AfterContentInit, OnDestroy {
  @Input() swiperMinWidth: number = 768;
  @Input() set config(val: SwiperOptions) {
    if (val) this._config = { ...this.defaultConfig, ...val };
  }
  get config(): SwiperOptions {
    return this._config;
  }
  _config: SwiperOptions = {};

  @Input() defaultClass: string;
  defaultConfig: SwiperOptions = {
    pagination: true,
    breakpoints: {
      768: {
        slidesPerView: 1,
      },
      992: { slidesPerView: 2 },
    },
  };
  @Input() index: number = 0;

  private swiperInstance: Swiper | null = null;
  private slidesSubscription?: Subscription;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    public sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
  ) {
    this.config = { ...this.defaultConfig, ...this.config };
  }

  mdq: MediaQueryList;
  mediaQueryListener: () => void;
  @ContentChildren(PrSlideComponent) set inputSlides(
    slides: QueryList<PrSlideComponent>,
  ) {
    this._inputSlides = slides;
    this.slides = this.inputSlides.toArray();
  }
  get inputSlides() {
    return this._inputSlides;
  }
  _inputSlides;
  @ViewChild('swiperContainer', { static: false }) swiperContainer?: ElementRef<HTMLElement>;
  @ViewChild('swiperDisplay') swiperDisplay: TemplateRef<any>;
  @ViewChild('defaultDisplay') defaultDisplay: TemplateRef<any>;

  public slides: PrSlideComponent[];

  initSwiper() {
    if (this.swiperContainer && !this.swiperInstance) {
      const container = this.swiperContainer.nativeElement;
      this.swiperInstance = new Swiper(container, {
        ...withNavigationButtons(this._config, container),
        initialSlide: this.index,
      });
    }
  }

  private resetSwiper(): void {
    if (!this.swiperInstance) return;
    this.swiperInstance.update();
    this.swiperInstance.slideTo(0, 0);
  }

  ngAfterViewInit() {
    if (this.config.init || this.swiperMinWidth == 0)
      setTimeout(() => this.initSwiper(), 0);
    else {
      this.mdq = this.media.matchMedia(`(max-width: ${this.swiperMinWidth}px)`);
      setTimeout(() => this.initMediaQuery(), 0);
      this.cdr.detectChanges();
    }
  }

  initMediaQuery() {
    if (this.mdq.matches) this.initSwiper();
    this.mediaQueryListener = () => {
      this.changeDetectorRef.detectChanges();
      if (this.mdq.matches) this.initSwiper();
    };
    this.mdq.addListener(this.mediaQueryListener);
  }

  public ngAfterContentInit(): void {
    this.slides = this.inputSlides.toArray();
    this.slidesSubscription = this.inputSlides.changes.subscribe(() => {
      this.slides = this.inputSlides.toArray();
      setTimeout(() => this.resetSwiper(), 0);
    });
  }

  ngOnDestroy(): void {
    this.slidesSubscription?.unsubscribe();
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}
